var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Editor"
    }
  }, [_c('nav', [_c('ol', _vm._l((_vm.resume.config), function(item, index) {
    return _c('li', {
      class: {
        active: item.field === _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.selected = item.field
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "viewBox": "0 0 200 200",
        "preserveAspectRatio": "none"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.icon))
      }
    })])])
  }))]), _vm._v(" "), _c('ol', {
    staticClass: "panels"
  }, _vm._l((_vm.resume.config), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.field === _vm.selected),
        expression: "item.field===selected"
      }]
    }, [(_vm.resume[item.field] instanceof Array) ? _c('div', _vm._l((_vm.resume[item.field]), function(subitem, i) {
      return _c('div', {
        staticClass: "subitem"
      }, _vm._l((subitem), function(value, key) {
        return _c('div', {
          staticClass: "resumeField"
        }, [_c('label', [_vm._v("\n                " + _vm._s(key) + "\n                "), _c('input', {
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": value
          },
          on: {
            "input": function($event) {
              _vm.changeResumeField(((item.field) + "." + i + "." + key), $event.target.value)
            }
          }
        })])])
      }))
    })) : _vm._l((_vm.resume[item.field]), function(value, key) {
      return _c('div', {
        staticClass: "resumeField"
      }, [_c('label', [_vm._v("\n          " + _vm._s(key) + "\n        "), _c('input', {
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": value
        },
        on: {
          "input": function($event) {
            _vm.changeResumeField(((item.field) + "." + key), $event.target.value)
          }
        }
      })])])
    })], 2)
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79c7f028","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 5BXv
// module chunks = 1